let controller = function(
	$scope, 
	$rootScope,
	$q, 
	$stateParams,
	$ionicLoading,
	$timeout, 
	$state, 
	$filter, 
	Compare, 
	Filter, 
	Process,
	Category
) {
	'ngInject'

	var vm = this;
	var timeout;
	var cardCopy;
	// Animation speed
	var speed = 500;
	var snapshot;
	var category
	var filters;

	vm.init = false;

	function initialize() {
		vm.init = true;

		vm.speed = speed;
		vm.animation = false;
		vm.products = Compare.assess(snapshot.products);
		vm.definitions = filters.definitions;
		vm.snapshot = snapshot;
		vm.start = true;
		vm.dismiss = false;
		vm.category = category;

		vm.filters = filters;
		vm.actives = {
			categories:snapshot.category_id,
			definitions:snapshot.definitions,
			brands:snapshot.brands,
			filters:snapshot.filters,
			price:snapshot.price,
		};

		vm.cards = [
			{
				id: 'left',
				flip: false,
				show: false,
				move: false,
				anim: false
			}, {
				id: 'center',
				flip: false,
				show: false,
				move: false,
				anim: false
			}, {
				id: 'right',
				flip: false,
				show: false,
				move: false,
				anim: false
			}
		];	

		$timeout(function() {
			angular.forEach(vm.cards, function(c) {
				c.show = true;
			});
		}, 500);

		$timeout(function() {
			Process.modals.start(false);
		}, 2000);
	}

	function promises() {
		Process.snapshot($stateParams.snapshot).then(function(res) {
			snapshot = res;
			Filter.setActive('brands', res.brands?res.brands.map((x)=>parseInt(x)):undefined);
			Filter.setActive('filters', res.filters);
			Filter.setActive('definitions', res.definitions?res.definitions.map((x)=>parseInt(x)):undefined);
			Filter.setActive('price', res.price);
			return Category.get(snapshot.category_id)
		}).then(function(res) {
			category = res;
			return Filter.get({categories:category.id})
		}).then(function(res) {
			filters = res;
			Filter.loadInterface(filters);
			initialize();
		});
	}

	vm.choose = function(key, product) {
		// Activate animation
		if(!vm.animation){
			vm.unlocked = false;
			vm.animation = true;
			product.loading = true;
			vm.border = true;
			// Determine card position
			var card = 0;
			if(key === 'c' || key === 'r') {
				card = (key === 'c' ? 1 : 2);
			}

			vm.chosenProduct = product;

			cardCopy = card;
			
			// Prepare for redirect to ranking if step > 3 or product count <= 3
			if((vm.snapshot.step >= 3 || vm.snapshot.pool <= 3) && true) {
				toRanking(product.id);
			} else {
				// hide cards that are not picked
				hideAndMoveCards(card).then(function() {
					// Retrieve next snapshot data
					nextSnapshot('PICK', product.id).then(function() {
						// Reset card statusses	
						resetCards(card).then(function() {
							// Done
							$rootScope.$broadcast('PROCESS_DONE');
							$ionicLoading.hide();
							product.loading = false;
							vm.animation = false;
						});
					});
				});
			}
		}
	};
	
	vm.getPosition = function(i) {
		return vm.cards[i].id;
	};
	
	vm.flip = function(i) {
		vm.start = false;
		vm.cards[i].flip = !vm.cards[i].flip;
	};

	vm.toRanking = function() {
		$state.go('tab.ranking');
	}
	
	vm.previousSnapshot = function(id) {
		// Activate animation
		vm.animation = true;
		vm.dismiss = true;
		getSnapshot(id);
	}

	function lastAction(id) {
		return Process.action({ 
			action: 'PICK', 
			value: id,
			price: vm.actives.price,
			filters: vm.actives.filters,
			definitions: vm.actives.definitions,
			brands: vm.actives.brands
		});
	};

	function nextSnapshot(action, id, attributeId) {
		var time = 0;

		vm.start = false;
		
		return Process.action({
			action: action, 
			value: id, 
			attribute_id: attributeId,
			price: vm.actives.price,
			filters: vm.actives.filters,
			definitions: vm.actives.definitions,
			brands: vm.actives.brands
		}).then(function(res) {
			time = 0;

			if (action === 'PICK') {
				vm.products.c = vm.chosenProduct;
				//Hide the translated element instantly.
				vm.cards[cardCopy].show = false;
				vm.cards[cardCopy].middle = false;

				vm.cards[1].anim = true;
				vm.cards[1].show = true;
			} else {
				$ionicLoading.show();
			}
			
			if (action === 'FILTER' || action === 'BRAND' || action === 'RANGE' || action === 'PRICE') {
				time = 400;
			}
			// Action posted
			$rootScope.$broadcast('APPLIED_FILTERS');


			$timeout.cancel(timeout);
			timeout = $timeout(function() {
				// Retrieve new snapshot data
				return getSnapshot();
				
			}, time);

			return timeout;

		}).catch(err => {
			$rootScope.$broadcast('PROCESS_DONE');
			vm.animation = false;
		}).finally(() => {
			$ionicLoading.hide();
		});
	};

	function getSnapshot(id) {
		return Process.snapshot(id).then(function(res) {
					
			Filter.setActive('brands', res.brands?res.brands.map((x)=>parseInt(x)):undefined);
			Filter.setActive('filters', res.filters);
			Filter.setActive('definitions', res.definitions?res.definitions.map((x)=>parseInt(x)):undefined);
			Filter.setActive('price', res.price);
			Filter.change(true);

			if(cardCopy && !vm.dismiss) {
				vm.cards[cardCopy].move = false;
			}
			
			var timeout = 10;
			if(vm.dismiss) {	
				timeout = speed;
		
				var oldProductList = [vm.products.l.id,vm.products.c.id,vm.products.r.id];
				var newProductList = [res.products.l.id,res.products.c.id,res.products.r.id];
		
				angular.forEach(newProductList, function(id, i) {
					if(id != oldProductList[i]) {
						vm.cards[i].show = false;
					}
				});
			}

			return $timeout(function() {	
				vm.products = Compare.assess(res.products);
				vm.definitions = res.definitions;
				vm.snapshot = res;
				vm.animation = false;

				if(vm.dismiss) {	
					angular.forEach(vm.cards, function(card) {
						card.show = true;
					});
					vm.dismiss = false;
				}
				// Stop loader
				$rootScope.$broadcast('PROCESS_DONE');
				$ionicLoading.hide();
			}, timeout);

		}).catch(function(err) {
			$ionicLoading.hide();
			vm.animation = false;
			return $q.reject();
		});
	}
	
	function hideAndMoveCards(card) {
		angular.forEach(vm.cards, function(c, i) {
			if(card !== i) {
				c.show = false;
			} else {
				c.move = true;
			}
		});
		
		return $q.resolve();
	};
	
	function resetCards() {
		angular.forEach(vm.cards, function(c, i) {
			c.move = false;
			c.show = (i === 1 ? true : false);
			c.flip = false;
			c.anim = false;
		});

		return $timeout(function() {
			angular.forEach(vm.cards, function(c, i) {
				c.show = true;
			});
		}, speed);
	};

	function toRanking(id){
		Process.modals.end(true);
		$rootScope.$broadcast('PROCESS_MODAL_END', true, category);
		lastAction(id).then(function() {
			$state.go('tab.ranking');
		});
	};

	$scope.$on('filters:changed', function() {
		vm.actives = Filter.actives();
	});

	$scope.$on('filters:action', function(e, action, value, attributeId) {
		// Activate animation
		vm.animation = true;
		vm.dismiss = true;

		vm.actives = Filter.actives();
		
		// Retrieve next snapshot data
		nextSnapshot(action, value, attributeId);
	});
	
	$scope.$on('PREVIOUS_PAGE', function() {
		angular.forEach(vm.cards, function(c) {
			c.show = false;
		});
		vm.animation = true;
	});

	$scope.$on('$ionicView.loaded', function(e, data) {
		promises();
	})

}

export default controller;




// WEBPACK FOOTER //
// ./app/components/process/process.controller.js